module.exports = __webpack_public_path__ + "img/main.f01e4020.png";